import { useEffect, useState } from 'react'
import axios from 'axios';
import useConfirm from '../../../hooks/useConfirm';
import useModalStore from '../../../zustand/store/useModalStore';
import { useIs17Inch } from '../../../hooks/useBreakPoint';

import * as Icons from '../../../images/icons/icons_component';

const JoinStep2 = ({setLoginStep, setJoinInfo}) => {

    const [authenticated, setAuthenticated] = useState(false);
    const [userAuthInfo, setuserAuthInfo] = useState({
        ci: '',
        di: '',
        diCheck: '',
        userMoblphon: '',
        userName: ''
    });

    const handleNiceAuth = async () => {
        const res = await axios.post('/commonapi/nice/main.do');
        const { encData } = res.data;

        // form 생성 후 전송 (팝업 방식)
        const form = document.createElement('form');
        form.setAttribute('name', 'form_chk');
        form.setAttribute('method', 'post');
        form.setAttribute('action', 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb');
        form.setAttribute('target', 'nicePopup');

        const input = document.createElement('input');
        input.setAttribute('type', 'hidden');
        input.setAttribute('name', 'EncodeData');
        input.setAttribute('value', encData);
        form.appendChild(input);
        const input2 = document.createElement('input');
        input2.setAttribute('type', 'hidden');
        input2.setAttribute('name', 'm');
        input2.setAttribute('value', 'checkplusSerivce');
        form.appendChild(input2);
        document.body.appendChild(form);

        window.open('', 'nicePopup', 'width=400,height=600');
        form.submit();
    };

    useEffect(() => {
        const handler = (event) => {
            const data = event.data;
            if (data && data.di) {
                setAuthenticated(true);
                setuserAuthInfo(data);
                console.log('본인 인증 결과:', data);
                // 이후 처리 로직 작성
            }
        };

        window.addEventListener('message', handler);
        return () => {
            window.removeEventListener('message', handler);
        };
    }, []);

    // confirm hook
    const confirm = useConfirm();
    const showNotiModal = useModalStore(state => state.showNotiModal);

    const handleNext = () => {
        if (!authenticated) {
            showNotiModal('본인인증을 해주시기 바랍니다.');
            return;
        }
        setJoinInfo((prev) => ({
            ...prev,
            userName: userAuthInfo.userName,
            userIpinDi: userAuthInfo.di,
            userIpinCi: userAuthInfo.ci,
            userCertDate: userAuthInfo.hpCertDate
        }))
        setLoginStep(3);
    };

    const handleCancel = async () => {
        if(authenticated) {
            const ok = await confirm('인증 내역이 사라집니다.\n 이전 페이지로 돌아가시겠습니까?');
            if(!ok) return false;
        }
        setLoginStep(1);
    };

    const is17Inch = useIs17Inch();
    
    return (
        <div className='join_contents'>
            <input type='hidden' id='userName' name='userName' value={userAuthInfo.userName} />
            <input type='hidden' id='ipinDi' name='ipinDi' value={userAuthInfo.di} />
            <input type='hidden' id='ipinCi' name='ipinCi' value={userAuthInfo.ci} />
            <input type='hidden' id='userMoblphon' name='userMoblphon' value={userAuthInfo.userMoblphon} />
            <input type='hidden' id='hpCertDate' name='hpCertDate' value={userAuthInfo.hpCertDate} />
            <input type='hidden' id='ipinCertDate' name='ipinCertDate' />
            <div className={`flex flex-col ${is17Inch ? 'gap-2' : 'gap-5'}`}>
                <hr/>
                    {!authenticated ? (
                        <div className='flex gap-8 items-center'>
                            <div className='content_section p-4 find_img_media_set'>
                                <Icons.IconIpin className='low_none_media_set' />
                                <span>본인 명의 I-PIN계정을 통해 인증을 확인합니다.<br />타인 명의 I-PIN계정으로는 본인인증이 불가합니다.</span>
                                <a href='#' id='btnIpin' className='auth_btn' title='새창-아이핀 인증'>아이핀 인증</a>
                            </div>
                            <h3 className='co_dark'>or</h3>
                            <div className='content_section p-4 find_img_media_set'>
                                <Icons.IconPhone className='low_none_media_set' />
                                <span>본인 명의의 휴대전화를 통해 본인 인증을<br />진행하실 경우 아래 버튼을 클릭하여 주십시요.</span>
                                <a href='#' id='btnNice' className='auth_btn' title='새창-휴대전화 인증' onClick={handleNiceAuth}>휴대전화 인증</a>
                            </div>
                        </div>
                    ) : (
                        <div className='content_section w-full p-10'>
                            <Icons.OkDalgu />
                            <h3>인증되었습니다.</h3>
                        </div>
                    )}
                <hr/>
                <div className='comm_btn_box h-12'>
                    <button className='comm_btn_w w-40' onClick={handleCancel} id='btnCancel' title='뒤로'>뒤로</button>
                    <button className='comm_btn bg_co_black w-40' onClick={handleNext} id='btnNext' title='다음'>다음</button>
                </div>
                {!authenticated ? (
                <>
                    <hr/>
                    <div>
                        <div className='flex gap-2'>
                            <div className='noti_section wp-60'>
                                <strong className='flex items-center'><Icons.NoticeIco16/>실명확인이 안될 경우</strong>
                                <p>연령이 만18세 이하이거나 외국인의 경우에는 한국신용평가(주) 콜센터에서 실명확인 등록신청을 해주시기 바랍니다.</p>
                                <div className='namecheck_box'>
                                    <a href='https://www.namecheck.co.kr/' target='_blank' title='새창-NICE평가정보 NICE아이디'><Icons.LogoNamecheck /><Icons.StHereRight16/></a>
                                    <a href='https://www.namecheck.co.kr/front/personal/register_howtoonline.jsp' target='_blank' title='새창-내국인 실명 확인 등록'><span><strong>내국인 </strong>실명 확인 등록</span><Icons.StHereRight16/></a>
                                    <a href='https://www.namecheck.co.kr/front/personal/register_foreigner.jsp' target='_blank' title='새창-외국인 실명 확인 등록'><span><strong>외국인 </strong>실명 확인 등록</span><Icons.StHereRight16/></a>
                                </div>
                                <p><strong>전화문의 : (국번없이)1600-1522 </strong>/ (통화가능시간 : 평일 09시 ~ 12시, 13시 ~ 18시), 토요일 및 공휴일 휴무</p>
                                <p><strong>메일문의 : callcenter@nice.com</strong><br />
                                    평일 오후 8시 30분 ~ 12시 사이에 접수된 인터넷 등록 요청은 다음 업무시간에 처리됩니다.<br />
                                    실명등록에 소요되는 시간은 업무시간 기준 1시간 내외 입니다.<br />
                                    업무 시간 외에 접수된 건은 다음 업무일 업무 시간에 처리됩니다
                                </p>
                            </div>
                            <div className='noti_section wp-40'>
                                <strong className='flex items-center'><Icons.NoticeIco16/>안내 및 주의사항</strong>
                                <p>응급의료지원센터는 인터넷 실명제를 통해 회원간의 신뢰성 확보와 원활한 서비스 이용을 위해 회원님의 본인인증을 받고 있습니다.</p>
                                <p>개인정보 보호와 주민등록번호 부정 사용으로 인한 피해를 방지하기 위해 회원정보를 확인해 주시기 바랍니다.</p>
                                <p>본인인증은 한국신용평가(주)와 아이핀 인증기관을 통해 받고 있으며, 회원가입 시 회원님의 주민등록번호는 저장되지 않습니다.</p>
                                <span className='co_red'>※ 개정된 '주민등록법'에 의해 타인의 주민등록번호를 부정 사용하는 자는 3년 이하의 징역 또는 1천만원 이하의 벌금이 부과될 수 있습니다. 관련법률 : 주민등록법 제21조(벌칙)제2항9호(시행일 2006.09.25)</span>
                            </div>
                        </div>
                    </div>
                </>
                ) : ('')}
            </div>
        </div>
    )
}

export default JoinStep2;